import { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function UpdateUserModal({
  open,
  onClose,
  token,
  usermanId,
  user, // row data (name, group_name, shared_users, disabled)
  onSuccess,
}) {
  const [form, setForm] = useState({
    password: "",
    group: "",
    sharedUsers: 1,
    disabled: false,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setForm({
        password: "",
        group: user.group_name || "default",
        sharedUsers: user.shared_users || 1,
        disabled: Boolean(user.disabled),
      });
    }
  }, [user]);

  if (!open || !user) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!usermanId || !user.name) {
      Swal.fire("Error", "Data user tidak valid", "error");
      return;
    }

    const updates = {};

    if (form.password) updates.password = form.password;
    if (form.group) updates.group = form.group;
    if (form.sharedUsers) updates["shared-users"] = Number(form.sharedUsers);
    updates.disabled = form.disabled ? "yes" : "no";

    if (Object.keys(updates).length === 0) {
      Swal.fire("Info", "Tidak ada perubahan", "info");
      return;
    }

    setLoading(true);
    try {
      console.log(updates);
      const res = await fetch(
        "https://api.wifikamu.my.id/userman-user-update",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            userman_id: usermanId,
            targetUsername: user.name,
            updates,
          }),
        }
      );

      const json = await res.json();

      if (!res.ok || !json.success) {
        throw new Error(json.message || "Gagal update user");
      }

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: json.message,
        timer: 1500,
        showConfirmButton: false,
      });

      onClose();
      onSuccess?.();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-lg rounded-lg bg-white dark:bg-slate-900 p-6">
        <h2 className="text-lg font-semibold mb-4">Update User</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Username (readonly) */}
          <div>
            <label className="block text-sm mb-1">Username</label>
            <input
              value={user.name}
              disabled
              className="w-full px-3 py-2 rounded border bg-slate-100 dark:bg-slate-800 dark:border-slate-700"
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm mb-1">
              Password (kosongkan jika tidak diubah)
            </label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border dark:border-slate-700 dark:bg-slate-800"
            />
          </div>

          {/* Group */}
          <div>
            <label className="block text-sm mb-1">Group</label>
            <input
              type="text"
              name="group"
              value={form.group}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border dark:border-slate-700 dark:bg-slate-800"
            />
          </div>

          {/* Shared Users */}
          <div>
            <label className="block text-sm mb-1">Shared Users</label>
            <input
              type="number"
              min={1}
              name="sharedUsers"
              value={form.sharedUsers}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded border dark:border-slate-700 dark:bg-slate-800"
            />
          </div>

          {/* Disabled */}
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              name="disabled"
              checked={form.disabled}
              onChange={handleChange}
            />
            <span>Disabled</span>
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-2 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded border dark:border-slate-700"
            >
              Cancel
            </button>
            <button
              disabled={loading}
              type="submit"
              className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
